import { useHydratedValue } from '@muse-web/router'

import { getUserAtLoad } from '../services/seedCurrentUser'

import { type TCurrentUser, useCurrentUser } from './useCurrentUser'

export const useHydratedCurrentUser = (): TCurrentUser => {
    const user = useCurrentUser()
    const userAtLoad = getUserAtLoad()

    return useHydratedValue(
        user,
        userAtLoad
            ? {
                  ...userAtLoad,
                  isAuthenticated: userAtLoad.id !== 0,
                  isLoading: false,
                  isRefreshing: false,
              }
            : user,
    )
}
